/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

// Bellow pattern taken from
// https://medium.com/@martin_hotell/improved-redux-type-safety-with-typescript-2-8-2c11a8062575
export function createAction<T extends string>(type: T): { type: T };
export function createAction<T extends string, P>(type: T, payload: P): { type: T; payload: P };
export function createAction<T extends string, P>(type: T, payload?: P): { type: T } | { type: T; payload: P } {
    return payload === undefined ? { type } : { type, payload };
}
